import { lazy } from 'react'

import { PermissionGroupDocument } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'

import { getSettingPageMeta } from 'modules/settings/lib/getSettingPageMeta'

const PermissionsRootPage = lazy(
  () => import('modules/permissions/pages/settings/PermissionsRootPage')
)

const PermissionsIndexRootPage = lazy(
  () => import('modules/permissions/pages/settings/PermissionsIndexRootPage')
)

const PermissionsShowRootPage = lazy(
  () => import('modules/permissions/pages/settings/PermissionsShowRootPage')
)

const ChangeGroupPageModalPage = lazy(
  () => import('modules/permissions/pages/settings/ChangeGroupPageModalPage')
)

const DelegatePermissionGroupPage = lazy(
  () => import('modules/permissions/pages/settings/DelegatePermissionGroupPage')
)

const EmployeesPage = lazy(() => import('modules/permissions/pages/settings/EmployeesPage'))

const ExternalsChangeGroupPageModalPage = lazy(
  () => import('modules/permissions/pages/settings/ExternalsChangeGroupPageModalPage')
)

const ExternalsPage = lazy(() => import('modules/permissions/pages/settings/ExternalsPage'))

const PermissionGroupPage = lazy(
  () => import('modules/permissions/pages/settings/PermissionGroupPage')
)

const VisibilityPage = lazy(() => import('modules/permissions/pages/settings/VisibilityPage'))

const settingsRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.settings.permissions.path,
      element: <PermissionsRootPage />,
      handle: {
        meta: () => {
          return getSettingPageMeta(navigation, 'permissions')
        },
      },
      children: [
        {
          index: true,
          element: <PermissionsIndexRootPage />,
        },
        {
          path: navigation.settings.permissions.id.path,
          element: <PermissionsShowRootPage />,
          children: [
            {
              index: true,
              element: <PermissionGroupPage />,
              handle: {
                meta: ({ params, watchQuery }) => {
                  return watchQuery({
                    query: PermissionGroupDocument,
                    variables: {
                      id: Number(params['id']),
                    },
                  }).map((result) => {
                    return {
                      title: `${result?.data?.permissions.permissionGroup?.name}`,
                      description: i18n.t('company_settings.general.permissions.description'),
                    }
                  })
                },
              },
            },
            {
              path: navigation.settings.permissions.id.delegate.path,
              element: <DelegatePermissionGroupPage />,
              handle: {
                meta: ({ params, watchQuery }) => {
                  return watchQuery({
                    query: PermissionGroupDocument,
                    variables: {
                      id: Number(params['id']),
                    },
                  }).map((result) => {
                    return {
                      title: `${result?.data?.permissions.permissionGroup?.name}`,
                      description: i18n.t('company_settings.general.permissions.description'),
                    }
                  })
                },
              },
            },
            {
              path: navigation.settings.permissions.id.visibility.path,
              element: <VisibilityPage />,
              handle: {
                meta: ({ params, watchQuery }) => {
                  return watchQuery({
                    query: PermissionGroupDocument,
                    variables: {
                      id: Number(params['id']),
                    },
                  }).map((result) => {
                    return {
                      title: `${result?.data?.permissions.permissionGroup?.name}`,
                      description: i18n.t('company_settings.general.permissions.description'),
                    }
                  })
                },
              },
            },
            {
              path: navigation.settings.permissions.id.employees.path,
              element: <EmployeesPage />,
              handle: {
                meta: ({ params, watchQuery }) => {
                  return watchQuery({
                    query: PermissionGroupDocument,
                    variables: {
                      id: Number(params['id']),
                    },
                  }).map((result) => {
                    return {
                      title: `${result?.data?.permissions.permissionGroup?.name}`,
                      description: i18n.t('company_settings.general.permissions.description'),
                    }
                  })
                },
              },
              children: [
                {
                  path: navigation.settings.permissions.id.employees.userIdAssign.path,
                  element: <ChangeGroupPageModalPage />,
                },
              ],
            },
            {
              path: navigation.settings.permissions.id.externals.path,
              element: <ExternalsPage />,
              handle: {
                meta: ({ params, watchQuery }) => {
                  return watchQuery({
                    query: PermissionGroupDocument,
                    variables: {
                      id: Number(params['id']),
                    },
                  }).map((result) => {
                    return {
                      title: `${result?.data?.permissions.permissionGroup?.name}`,
                      description: i18n.t('company_settings.general.permissions.description'),
                    }
                  })
                },
              },
              children: [
                {
                  path: navigation.settings.permissions.id.externals.userIdAssign.path,
                  element: <ExternalsChangeGroupPageModalPage />,
                },
              ],
            },
          ],
        },
      ],
    },
  ]
}

export default settingsRoutes
